module.exports = __webpack_public_path__ + "img/bb4.f2830429.jpg";